import type { BarChartType } from './components/BarChart/types';
import type { AnalyticsAggregation } from './redux/types';

export const CHART_TYPE_TO_AGGREGATION: Record<BarChartType, AnalyticsAggregation> = {
  daily: 'DAILY',
  weekly: 'WEEKLY',
  monthly: 'MONTHLY',
};

export const PAGE_OFFSET_CENTER = 100;
export const PAGE_OFFSET_COUNT = 200;

export const PAGINATION_BUTTON_SX = {
  '& .MuiPagination-ul': { gap: '4px' },
  '& .MuiPaginationItem-root': {
    backgroundColor: '#272727',
    color: '#fff',
    '&:hover': { backgroundColor: '#3a3a3a' },
    '&.Mui-disabled': {
      backgroundColor: 'action.disabledBackground',
      color: 'action.disabled',
      opacity: 0.5,
    },
  },
} as const;

export const CARD_SX = {
  border: '1px solid',
  borderColor: 'ghost.extraLight',
  borderRadius: '8px',
  padding: 3,
  flex: 1,
} as const;
